var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8044 0H8.77086V12.2608C8.77086 13.7218 7.60414 14.9218 6.1522 14.9218C4.70025 14.9218 3.53352 13.7218 3.53352 12.2608C3.53352 10.8261 4.67433 9.65215 6.07443 9.6V6.52175C2.98904 6.5739 0.5 9.10435 0.5 12.2608C0.5 15.4435 3.04089 18 6.17814 18C9.31533 18 11.8562 15.4174 11.8562 12.2608V5.9739C12.997 6.8087 14.3971 7.30435 15.875 7.33045V4.25217C13.5934 4.17391 11.8044 2.29565 11.8044 0Z","fill":"white"}));
}

Tiktok.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
